import store from '@/store';

const permissionChecker = () => store.getters['dh/hasPermission'] || store.getters['cms/hasPermission'];

const routes = [
    {
        name: 'medias.index',
        path: '/media-library/',
        component: () => {
            return import('@/views/media_gallery/Index');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'media library',
            title: 'media library',
            size: 'large',
            flowStartsWith: 'medias.index',
            product: 'media-gallery',
            permissionChecker,
        },
    },
    {
        name: 'medias.show',
        path: '/media-library/file/:id',
        component: () => {
            return import('@/views/media_gallery/Show');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'view media',
            title: 'view media',
            size: 'large',
            flowStartsWith: 'medias.index',
            product: 'media-gallery',
            requiresCustomer: true,
            requiresCommunity: false,
            permissionChecker,
        },
    },
    {
        name: 'medias.edit',
        path: '/media-library/file/:id/edit',
        component: () => {
            return import('@/views/media_gallery/Edit');
        },
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'edit media',
            title: 'media library',
            size: 'large',
            flowStartsWith: 'medias.index',
            product: 'media-gallery',
            requiresCustomer: true,
            requiresCommunity: false,
            permissionChecker,
        },
    },
];

export default routes;
